import React from "react";
import { Route, Routes } from "react-router-dom";
import Dashboard from "./dashboard";
import FrontPage from "./frontPage";

const Routers = () => {
  return (
    <>
      <Routes>
        <Route path="/*" index element={<FrontPage />} />
        <Route path="/dashboard/*" element={<Dashboard />} />
      </Routes>
    </>
  );
};

export default Routers;
